import { FC } from "react";
import EventListItem from "@modules/for-you/components/EventListItem";
import cx from "classnames";
import { useEventsList } from "@modules/for-you/hooks";
import { Typography } from "@earned/core";

const EventsList: FC = () => {
  const { eventItems } = useEventsList();

  return (
    <div className="gap-3.5 pb-8 pt-8 lg:max-w-[293px] lg:pb-[51px]">
      <div className="border-b border-primary pb-8">
        <Typography variant="body-xl" weight="medium" color="primary">
          Events <span className="font-normal">For You</span>
        </Typography>
      </div>
      <div className={cx("flex flex-col gap-3")}>
        {eventItems.map((event) => (
          <EventListItem key={event.ID} event={event} />
        ))}
      </div>
    </div>
  );
};

export default EventsList;
